//import { delay } from 'redux-saga'
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { fetchApiData } from '../auth';
import { DATA_API } from '../constants';
import { APP_GET_DATA, appGetDataSuccess, appGetDataFailure } from '../actions';

function* fetchData() {
  try {

    const data = yield call(fetchApiData(DATA_API));
    yield put(appGetDataSuccess(data));

  } catch (error) {
    yield put(appGetDataFailure(error));
  }
}

export function* watchGetData() {
  yield takeEvery([APP_GET_DATA], fetchData);
}
export const appFetchPhotos = fetchData.bind(null);

export default function* rootSaga() {
  yield all([watchGetData()]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js